import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {IToast} from './interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toast: Subject<IToast> = new Subject<IToast>();
  constructor() { }

  show(item: IToast) {
    this.toast.next(item);
  }
}
